import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Nav, NavLink, Row, TabContent, TabPane } from "reactstrap"
import {
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import {
  createProductCategory,
  getCategories,
  resetProductCategory,
  updateProductCategory,
} from "store/actions"
import { getFileBlob } from "utils"
import DetailsTab from "./detailsTab"
import FormTab from "./formTab"
import { DEFAULT_FORM_FIELDS, FORM_FIELDS } from "./utils"

const Categories = ({
  handleBack,
  vendorId,
  createProductCategory,
  handleSubmit,
  selectedProductCategory,
  categoryName,
  resetProductCategory,
  initializeForm,
  getCategories,
  loading,
  updateProductCategory,
  formTabValues,
  setSubTabBreadcrumb,
}) => {
  const TABS = {
    DETAILS: 1,
    FORM: 3,
  }

  const [activeTab, setActiveTab] = useState(TABS.DETAILS)

  useEffect(() => {
    setSubTabBreadcrumb([
      {
        title: selectedProductCategory
          ? "Edit Product Group"
          : "Create Product Group",
        type: "tab",
        clickHandler: () => {
          setActiveTab(TABS.DETAILS)
        },
      },
      { title: activeTab === 1 ? "Add Details" : "Create Form" },
    ])
  }, [activeTab, selectedProductCategory])

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    return () => {
      resetProductCategory()
      getCategories({ type: 3 })
    }
  }, [])

  useEffect(() => {
    const forms = [
      ...DEFAULT_FORM_FIELDS.filter(
        field => !field?.hideFromVendors?.includes(parseInt(parseInt(vendorId)))
      ),
      ...FORM_FIELDS.filter(field =>
        field?.vendors?.includes(parseInt(vendorId))
      ),
    ]
    if (selectedProductCategory) {
      const initialForms = selectedProductCategory?.extra?.form_fields
      for (let i = 0; i < forms?.length; i++) {
        const currentField = initialForms?.find(x => {
          if (typeof x === "string") {
            return x === forms[i]?.name
          } else {
            return x?.name === forms[i]?.name
          }
        })
        if (currentField) {
          forms[i].checked = true
          forms[i].profile = currentField?.profile
          forms[i].required = currentField?.required
        } else {
          forms[i].checked = false
        }
      }
      initializeForm({
        details: {
          name: selectedProductCategory?.name,
          inventory: selectedProductCategory?.inventory,
        },
        form: {
          formFields: forms,
          additionalImage: { editedImage: selectedProductCategory?.file_url },
          bannerImage: { editedImage: selectedProductCategory?.banner_url },
        },
      })
    } else {
      initializeForm({
        form: {
          formFields: forms,
        },
      })
    }
  }, [selectedProductCategory])

  const handleSave = data => {
    if (selectedProductCategory) {
      updateProductCategory({
        values: {
          vendor_id: selectedProductCategory?.vendor_id,
          type: selectedProductCategory?.type,
          order: selectedProductCategory?.order,
          name: data?.details?.name,
          extra: JSON.stringify({
            form_fields: data?.form?.formFields
              ?.filter(x => x?.checked)
              ?.map(x => ({
                name: x?.name,
                required: x?.required,
                profile: x?.profile,
                label: x?.label,
              })),
          }),
          delete_file: data?.form?.delete_additionalImage || 0,
          file:
            data?.form?.additionalImage?.editedImage &&
            getFileBlob(data?.form?.additionalImage?.editedImage),
          delete_banner: data?.form?.delete_banner || 0,
          banner:
            data?.form?.bannerImage?.editedImage &&
            getFileBlob(data?.form?.bannerImage?.editedImage),
          inventory: data?.details?.inventory,
        },
        id: selectedProductCategory?.id,
      })
    } else {
      createProductCategory({
        vendor_id: vendorId,
        name: data?.details?.name,
        type: 3,
        extra: JSON.stringify({
          form_fields: [
            {
              name: "first_name",
              label: "First Name",
              required: false,
              profile: false,
            },
            {
              name: "last_name",
              label: "Last Name",
              required: false,
              profile: false,
            },
            { name: "email", label: "Email", required: false, profile: false },
          ],
        }),
        file:
          data?.form?.additionalImage?.editedImage &&
          getFileBlob(data?.form?.additionalImage?.editedImage),
        banner:
          data?.form?.bannerImage?.editedImage &&
          getFileBlob(data?.form?.bannerImage?.editedImage),
        inventory: data?.details?.inventory,
      })
    }
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-between">
        <Col xs="auto" className="ms-5">
          {selectedProductCategory && (
            <h5 className="mt-1">
              Edit Product Group: {selectedProductCategory?.name}
            </h5>
          )}
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Done"
            color="light"
            onClick={handleBack}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="auto" className="ms-5">
          <Nav pills className="flex-column">
            <NavLink
              className={markIfIsActive(TABS.DETAILS)}
              onClick={() => setActiveTab(TABS.DETAILS)}
              style={
                activeTab === TABS.DETAILS ? {} : { backgroundColor: "#eff2f7" }
              }
            >
              {<span style={{ fontSize: "16px" }}>Add Details</span>}
            </NavLink>
            <NavLink
              className={markIfIsActive(TABS.FORM)}
              onClick={() => setActiveTab(TABS.FORM)}
              style={
                activeTab === TABS.FORM ? {} : { backgroundColor: "#eff2f7" }
              }
            >
              {<span style={{ fontSize: "16px" }}>Create Form</span>}
            </NavLink>
          </Nav>
        </Col>
        <Col>
          <TabContent activeTab={activeTab}>
            <TabPane style={{ animation: "none" }} tabId={TABS.DETAILS}>
              <FormSection name="details">
                <DetailsTab
                  tabIsActive={activeTab === TABS.DETAILS}
                  handleSave={handleSubmit(handleSave)}
                />
              </FormSection>
              <BottomNavigation
                handleNext={() => setActiveTab(TABS.FORM)}
                handleSave={handleSubmit(handleSave)}
                loading={loading}
              />
            </TabPane>
            <TabPane style={{ animation: "none" }} tabId={TABS.FORM}>
              <FormSection name="form">
                <FormTab
                  tabIsActive={activeTab === TABS.FORM}
                  handleSave={handleSubmit(handleSave)}
                />
              </FormSection>
              <BottomNavigation
                handleBack={() => setActiveTab(TABS.DETAILS)}
                handleSave={handleSubmit(handleSave)}
                saveButtonDisabled={
                  !categoryName || categoryName?.trim()?.length === 0
                }
                loading={loading}
              />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PRODUCT_CATEGORIES)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  selectedProductCategory:
    state.ProductsAndSubscriptions.selectedProductCategory,
  categoryName: selector(state, "details.name"),
  loading: state.ProductsAndSubscriptions.loading,
  formTabValues: selector(state, "form"),
})

const mapDispatchToProps = dispatch => ({
  createProductCategory: values => dispatch(createProductCategory(values)),
  resetProductCategory: () => dispatch(resetProductCategory()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.PRODUCT_CATEGORIES, values)),
  getCategories: values => dispatch(getCategories(values)),
  updateProductCategory: values => dispatch(updateProductCategory(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.PRODUCT_CATEGORIES,
  })(Categories)
)
